export const ACCOUNT_PREFERENCES = 'account.preferences';

export const lblPreferencePushNotificationTcpDownload =
  'lbl_preference_push_notification_Tcp_download';

export const lblPreferencePushNotificationGymboreeDownload =
  'lbl_preference_push_notification_Gymboree_download';

export const lblPreferencePushNotificationSnjDownload =
  'lbl_preference_push_notification_snj_download';

export const lblPreferencePushNotificationPjpDownload =
  'lbl_preference_push_notification_pjp_download';

export const lblPreferencePushNotificationHeading = 'lbl_preference_push_notification_heading';
export const lblPreferencePushNotificationSubtext = 'lbl_preference_push_notification_subtext';
export const lblPreferencePushNotificationNote = 'lbl_preference_push_notification_note';

export const lblPreferencePushUnsubscribeHeading = 'lbl_preference_push_unsubscribe_heading';
export const lblPrefrenceModalAreYouSure = 'lbl_prefrence_modal_are_you_sure';
export const lblPrefrenceModalClickingSubmitPushText =
  'lbl_prefrence_modal_clicking_submit_push_text';

export const lblPrefrenceSubscribeTextAlerts = 'lbl_prefrence_subscribe_text_alerts';
export const lblPrefrenceModalInfoText = 'lbl_prefrence_modal_info_text';
export const lblPrefrenceModalSubInfoText = 'lbl_prefrence_modal_sub_info_text';
export const lblPreferenceMobileNumber = 'lbl_preference_mobileNumber';

export const lblPrefrenceModalUnsubscribeTitle = 'lbl_prefrence_modal_unsubscribe_title';
export const lblPrefrenceModalClickingSubmitText = 'lbl_prefrence_modal_clicking_submit_text';

export const lblPrefrenceRewardsPrefrence = 'lbl_prefrence_rewards_prefrence';
export const lblPrefrenceAccessBuyOnlinePickup = 'lbl_prefrence_access_buy_online_pickup';
export const lblPrefrenceMarketingNotification = 'lbl_prefrence_marketing_notification';
export const lblPrefrenceAppText = 'lbl_prefrence_app_text';
export const lblPrefrenceAppAlarmIconText = 'lbl_prefrence_app_alarmIconText';
export const lblPrefrencePjpLabel = 'lbl_prefrence_pjp_label';
export const lblPrefrenceText = 'lbl_prefrence_text_text';
export const lblPrefrenceTextChatIconText = 'lbl_prefrence_text_chatIconText';
export const lblPhoneNotEligible = 'phone_not_eligible';

const MyPreferenceSubscriptionLabels = {
  account: {
    preferences: {
      [lblPreferencePushNotificationTcpDownload]: "Download The Children's Place App",

      [lblPreferencePushNotificationGymboreeDownload]: 'Download The Gymboree App',

      [lblPreferencePushNotificationSnjDownload]: 'Download The Sugar & Jade App',

      [lblPreferencePushNotificationPjpDownload]: 'Download The PJ Place App',

      [lblPreferencePushNotificationHeading]:
        'Subscribe to     My Place Rewards      Push Notifications',
      [lblPreferencePushNotificationSubtext]:
        'Click submit get Push Notifications on points updates, rewards, exclusive offers and more!',
      [lblPreferencePushNotificationNote]:
        'Note: Be sure to enable push notifications in the settings section of your mobile device.',
      [lblPreferencePushUnsubscribeHeading]:
        'Unsubscribe from My Place Rewards PUSH Notifications\t',
      [lblPrefrenceModalAreYouSure]: "Are you sure you'd like to unsubscribe",
      [lblPrefrenceModalClickingSubmitPushText]:
        "By clicking submit, you'll no longer receive rewards & points updates from our App",
      [lblPrefrenceSubscribeTextAlerts]: 'Join My Place Rewards Text Alerts',
      [lblPrefrenceModalInfoText]:
        'Enter your phone number to get Text Alert updates on points, rewards, exclusive offers and more!',
      [lblPrefrenceModalSubInfoText]:
        "After submitting, you'll receive a text message at the number provided; reply 'Y' to receive marketing and My Place Rewards Text Alerts.",
      [lblPreferenceMobileNumber]: 'Mobile Phone Number',
      [lblPrefrenceModalUnsubscribeTitle]: 'UNSUBSCRIBE FROM MY PLACE REWARDS TEXT ALERTS',
      [lblPrefrenceModalClickingSubmitText]:
        "By clicking submit, you'll no longer receive text notifications about rewards, points, coupons & special offers!",

      [lblPrefrenceRewardsPrefrence]: 'My Place Rewards Preferences',
      [lblPrefrenceAccessBuyOnlinePickup]:
        'In addition to emails, get Push Notification or Text Alert updates on points, rewards, exclusive offers and more.',
      [lblPrefrenceMarketingNotification]:
        "By opting into My Place Rewards text alerts, you'll also receive marketing notifications.",
      [lblPrefrenceAppText]: 'APP',
      [lblPrefrenceAppAlarmIconText]: '', // not used
      [lblPrefrencePjpLabel]: 'PJ Place',
      [lblPrefrenceText]: 'TEXTS',
      [lblPrefrenceTextChatIconText]: '', // not used,
      [lblPhoneNotEligible]:'Sorry, this phone number is not eligible to be subscribed.'
    },
  },
};
export default MyPreferenceSubscriptionLabels;
